<template>
  <div>
    <p class="invite-text">
      <i class="iconfont iconicon-test1" />
    </p>
    <h2 class="invite-company-desc">
      {{ $t('message["1438"]') }}
    </h2>
    <div class="join-btn">
      <cube-button
        type="submit"
        :primary="true"
        @click="toIndex"
      >
        {{ $t('message["537"]') }}
      </cube-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data () {
    return {
    }
  },
  methods: {
    toIndex () {
      this.$router.push({ name: 'OrgIndex' })
    }
  }
}
</script>

<style scoped lang="scss">
.invite-text {
  width: 327px;
  color: #888;
  line-height: 23px;
  font-size: 15px;
  text-align: center;
  .iconfont {
    font-size: 40px;
    color: #F57676;
  }
}
.invite-company-desc {
  width: 280px;
  text-align: center;
  color: #000;
  line-height: 28px;
  font-size: 18px;
  font-weight: 400;
  margin: 18px auto 12px auto
}
.join-btn {
  margin: 46px 0;
}
</style>
